module.exports = __webpack_public_path__ + "img/thumb_10.4fd5f4e8.jpg";